var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable no-restricted-globals */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Immutable from 'immutable';

import { Translate, t } from "../../I18N";
import SnippetList from "../../Documents/components/SnippetList";
import { selectSnippet } from "../../Viewer/actions/uiActions";
import { Form } from 'react-redux-form';
import { NumericRangeSlide } from "../../ReactReduxForms";
import { Icon } from "../../Layout/Icon";
import { TemplateLabel, DocumentLanguage } from "../../Layout";

const findResultsAboveThreshold = (results, threshold) => {
  const boundingIndex = results.findIndex(({ score }) => score < threshold);
  return boundingIndex >= 0 ? results.slice(0, boundingIndex) : results;
};

const getSnippetsFromResults = (results, template) => {
  const snippets = results.reduce(
    (_memo, item) => {
      const memo = _memo;
      const text = `${item.text} (${(item.score * 100).toFixed(2)}%)`;
      memo.count += 1;
      if (isNaN(Number(item.page))) {
        const field = template.
        get('properties').
        find((p) => p.get('name') === item.page).
        get('label');
        memo.metadata[field] = (memo.metadata[field] || []).concat([text]);
        return memo;
      }
      memo.fullText.push({
        page: Number(item.page),
        text
      });
      return memo;
    },
    { count: 0, metadata: {}, fullText: [] }
  );

  snippets.metadata = Object.keys(snippets.metadata).map((field) => ({
    field,
    texts: snippets.metadata[field]
  }));
  return snippets;
};

export class DocumentResults extends Component {
  renderSnippetsList(doc, snippets, documentViewUrl) {
    return (/*#__PURE__*/
      _jsx(SnippetList, {
        doc: Immutable.fromJS(doc),
        documentViewUrl: documentViewUrl,
        snippets: snippets,
        searchTerm: "",
        selectSnippet: (...args) => {
          this.props.selectSnippet(...args);
        } }
      ));

  }

  renderFilter() {
    const { threshold } = this.props;
    return (/*#__PURE__*/
      _jsx("dl", { className: "metadata-type-text" }, void 0, /*#__PURE__*/
      _jsx("dt", { className: "item-header" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Threshold"), " ", (threshold * 100).toFixed(2), " %"
      ), /*#__PURE__*/
      _jsx("dd", {}, void 0, /*#__PURE__*/
      _jsx(Form, { model: "semanticSearch.resultsFilters" }, void 0, /*#__PURE__*/
      _jsx(NumericRangeSlide, {
        model: ".threshold",
        min: 0.3,
        max: 1,
        step: 0.01,
        delay: 200,
        minLabel: t('System', 'Exploration'),
        maxLabel: t('System', 'Precision') }
      )
      )
      )
      ));

  }

  render() {
    const { doc, threshold, template } = this.props;

    if (!doc.semanticSearch) {
      return false;
    }
    const filteredResults = findResultsAboveThreshold(doc.semanticSearch.results, threshold);
    const snippets = Immutable.fromJS(getSnippetsFromResults(filteredResults, template));
    const documentViewUrl = doc.file ? `/document/${doc.sharedId}` : `/entity/${doc.sharedId}`;

    return (/*#__PURE__*/
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx("div", { className: "view" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "item-info" }, void 0, /*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx(Icon, { className: "item-icon item-icon-center", data: doc.icon }), /*#__PURE__*/
      _jsx("h1", { className: "item-name" }, void 0,
      doc.title, /*#__PURE__*/
      _jsx(DocumentLanguage, { doc: Immutable.fromJS(doc) })
      )
      ), /*#__PURE__*/
      _jsx(TemplateLabel, { template: doc.template })
      ),
      this.renderFilter(), /*#__PURE__*/
      _jsx("dl", { className: "metadata-type-numeric" }, void 0, /*#__PURE__*/
      _jsx("dt", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Number of sentences above threshold")
      ), /*#__PURE__*/
      _jsx("dd", {}, void 0, filteredResults.length)
      ), /*#__PURE__*/
      _jsx("dl", { className: "metadata-type-numeric" }, void 0, /*#__PURE__*/
      _jsx("dt", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "% of sentences above threshold")
      ), /*#__PURE__*/
      _jsx("dd", {}, void 0,
      (filteredResults.length / doc.semanticSearch.totalResults * 100).toFixed(2), "%"
      )
      )
      ),
      this.renderSnippetsList(doc, snippets, documentViewUrl)
      ));

  }
}

DocumentResults.defaultProps = {
  template: undefined
};


















const mapStateToProps = ({ semanticSearch, templates }) => ({
  threshold: semanticSearch.resultsFilters.threshold,
  template: templates.find(
    (tpl) => tpl.get('_id') === semanticSearch.selectedDocument.get('template')
  )
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ selectSnippet }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(DocumentResults);